import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-color-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './color-list.component.html',
  styleUrl: './color-list.component.scss'
})
export class ColorListComponent implements OnInit, OnDestroy {
  @Input() themeColors: any;
  @Input() textColors: any;
  @Input() secondryThemeColors: any;
  selectedThemeColor = '#1570EF'; // Default color
  selectedThemeSecColor = '#110646'; // Default color
  selectedTextColor = '#333333'; // Default color
  @Input() pickColorType: any;
  @Input() selectedColor: string;
  @Output() onColorSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNewColorAdded: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('colorPicker') colorPicker: ElementRef;

  constructor() {
  }

  ngOnInit(): void {
    if (this.pickColorType === 'theme'){
      this.selectedThemeColor = this.selectedColor;
    } else if(this.pickColorType === 'secondry-theme'){
      this.selectedThemeSecColor = this.selectedColor;
    } else {
      this.selectedTextColor = this.selectedColor;
    }
  }

  ngOnDestroy(): void {
  }

  addCustomColor(event) {
    const colorInput = event.target as HTMLInputElement;
    this.selectedThemeColor = colorInput.value;
    this.onNewColorAdded.emit({type: this.pickColorType, themeColor: this.selectedThemeColor, textColor: this.selectedTextColor});
  }

  addCustomTextColor(event) {
    const colorInput = event.target as HTMLInputElement;
    this.selectedTextColor = colorInput.value;
    this.onNewColorAdded.emit({type: this.pickColorType, themeColor: this.selectedThemeColor, textColor: this.selectedTextColor});
  }

  setSelectedColor(color) {
    if (this.pickColorType === 'theme') {
      this.selectedThemeColor = color;
    }
    if (this.pickColorType === 'text') {
      this.selectedTextColor = color;
    }
    if (this.pickColorType === 'secondry-theme') {
      this.selectedThemeSecColor = color;
    }
    this.onColorSelected.emit({type: this.pickColorType, themeColor: this.selectedThemeColor, textColor: this.selectedTextColor, secondryThemeColor:this.selectedThemeSecColor});
  }

  openColorPicker() {
    this.colorPicker.nativeElement.click();
  }

}
